module.exports = __webpack_public_path__ + "img/bg_audi.03d29166.jpg";